export default "__VITE_ASSET__BsLuEIq___"